import React from 'react';
import { XIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { Reveal } from './Reveal';
import { GoldBow } from './GoldBow';
import { scrollToLeadForm } from '../utils/scroll';
const TYPICAL = ['exp.typical.1', 'exp.typical.2', 'exp.typical.3', 'exp.typical.4', 'exp.typical.5'];
const QUEEN = ['exp.queen.1', 'exp.queen.2', 'exp.queen.3', 'exp.queen.4', 'exp.queen.5'];
export function QueenExperience() {
  const {
    t
  } = useLanguage();
  return <section className="w-full bg-offwhite" data-id="element-201" data-mp="3lbnhei2av1fh">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 md:py-24" data-id="element-202" data-mp="3lavstr74e3yp">
        <Reveal className="max-w-2xl" data-id="element-203" data-mp="2wcutkot1a1x">
          <p className="font-display text-[11px] font-bold uppercase tracking-[0.24em] text-camelink" data-id="element-204" data-mp="2zih6s61txty">
            {t('exp.eyebrow')}
          </p>
          <div aria-hidden="true" className="mt-3 h-[3px] w-12 bg-kred" data-id="element-205" data-mp="cusn3qzkipd0" />
          <h2 className="mt-5 font-display text-3xl font-extrabold uppercase leading-[1.02] tracking-[-0.02em] text-ink sm:text-5xl" data-id="element-206" data-mp="7wimv1yzkykj">
            {t('exp.title')}
          </h2>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-8" data-id="element-207" data-mp="12b5x4lohzsx0">
          <Reveal data-id="element-208" data-mp="12d9zv0anulvp">
            <div className="h-full border border-ink/10 bg-white/60 p-6 sm:p-8" data-id="element-209" data-mp="17aa558zorklr">
              <h3 className="font-display text-sm font-extrabold uppercase tracking-[0.18em] text-muted" data-id="element-210" data-mp="17cmvoajif3af">
                {t('exp.typicalTitle')}
              </h3>
              <ul className="mt-6 space-y-4" data-id="element-211" data-mp="1ga5lds83m5sn">
                {TYPICAL.map(key => <li key={key} className="flex items-start gap-3 text-base text-muted" data-id="element-212" data-mp="1l903ery8rqbp">
                    <XIcon aria-hidden="true" className="mt-1 h-4 w-4 shrink-0 text-muted/60" data-id="element-213" data-mp="1q0i2tbkm9iuk" />
                    <span data-id="element-214" data-mp="1v04h7oc6l54y">{t(key)}</span>
                  </li>)}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.1} data-id="element-215" data-mp="1z39hdk8sguqf">
            <div className="relative h-full border border-ink/10 border-t-2 border-t-camel bg-white p-6 sm:p-8" data-id="element-216" data-mp="240j3apwyyo9i">
              {/* Red as a point color: the badge only. Never a button fill. */}
              <span className="absolute -top-3 left-6 bg-kred px-3 py-1 font-display text-[10px] font-extrabold uppercase tracking-[0.2em] text-white" data-id="element-217" data-mp="3vxgf3j4v1kd">
                {t('exp.badge')}
              </span>
              <h3 className="mt-3 font-display text-sm font-extrabold uppercase tracking-[0.18em] text-ink" data-id="element-218" data-mp="8xcziq1r2y04">
                {t('exp.queenTitle')}
              </h3>
              <ul className="mt-6 space-y-4" data-id="element-219" data-mp="nkfwmvm5v4mx">
                {QUEEN.map(key => <li key={key} className="flex items-start gap-3 text-base font-medium text-ink" data-id="element-220" data-mp="imo542pfhkj9">
                    {/* The gold bow as the bullet marker. */}
                    <GoldBow className="mt-1 h-4 w-5 shrink-0" color="#B08355" strokeWidth={1.6} data-id="element-221" data-mp="rnclh42anwzb" />
                    <span data-id="element-222" data-mp="2ydsi6bv8eele">{t(key)}</span>
                  </li>)}
              </ul>
              <button type="button" onClick={scrollToLeadForm} className="mt-8 min-h-[52px] w-full bg-gold px-6 text-sm font-bold uppercase tracking-[0.12em] text-golddeep transition-transform hover:-translate-y-[1px]" data-id="element-223" data-mp="2tfqxjmi5q77t">
                {t('exp.cta')}
              </button>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}